module.exports = __webpack_public_path__ + "img/lock.8c9bc01e.svg";